'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function noop() {}

var fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};

var exportedLogger = fakeLogger,
    hls = void 0;

//let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function formatMsg(type, msg) {
  msg = '[' + type + '] > ' + msg;
  return msg;
}

function consolePrintFn(type) {
  var func = window.console[type];
  if (func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args[0]) {
        args[0] = formatMsg(type, args[0]);
      }
      func.apply(window.console, args);
    };
  }
  return noop;
}

function checkRepeatWrapper(func) {
  var lastMsg;
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (args.join(' ') === lastMsg) {
      return;
    }
    lastMsg = args.join(' ');
    func.apply(null, args);
  };
}

function exportLoggerFunctions(debugConfig) {
  for (var _len3 = arguments.length, functions = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    functions[_key3 - 1] = arguments[_key3];
  }

  functions.forEach(function (type) {
    exportedLogger[type] = checkRepeatWrapper(function () {
      var logFn = hls && hls.holaLog && hls.holaLog[type] || debugConfig[type] || consolePrintFn(type);
      logFn.apply(null, arguments);
    });
  });
}

var enableLogs = exports.enableLogs = function enableLogs(debugConfig, hlsObject) {
  hls = hlsObject;
  exportLoggerFunctions(debugConfig || fakeLogger,
  // Remove out from list here to hard-disable a log-level
  //'trace',
  'debug', 'log', 'info', 'warn', 'error');
  // Some browsers don't allow to use bind on console object anyway
  // fallback to default if needed
  try {
    exportedLogger.log();
  } catch (e) {
    exportedLogger = fakeLogger;
  }
};

var logger = exports.logger = exportedLogger;